import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var check_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M16.5 7.5 10 13.9l-2.5-2.4-1 1 3.5 3.6 7.5-7.6z" }) });
export {
  check_default as default
};
//# sourceMappingURL=check.js.map
